const ROOT_OPTION = { label: '/', value: { id: null, name: '/' } };

const walk = (nodes, parentPath) => {
  const folders = (nodes || []).filter((node) => node.type === 'folder');
  return folders
    .slice()
    .sort((a, b) => a.name.localeCompare(b.name))
    .flatMap((folder) => {
      const label = parentPath ? `${parentPath} / ${folder.name}` : folder.name;
      return [{ label, value: { id: folder.id, name: folder.name } }, ...walk(folder.children, label)];
    });
};

export const flattenFolderOptions = (tree) => [ROOT_OPTION, ...walk(tree, '')];
